import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-auth-wrapper',
  templateUrl: './wrapper.component.html',
  styleUrls: ['./wrapper.component.scss'],
})
export class WrapperComponent {
  @Input() name = 'Sign in';
  @Input() info = true;
}
